import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {
  Button,
  Card,
  Avatar,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Switch,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

function displayQuestion(question) {
  if (question == null || question === '') {
    return '';
  }
  if (typeof question === 'string') {
    try {
      const parsed = JSON.parse(question);
      if (parsed && typeof parsed === 'object') {
        return parsed.English || parsed.english || Object.values(parsed).find(Boolean) || question;
      }
    } catch (e) {
      return question;
    }
    return question;
  }
  if (typeof question === 'object') {
    return question.English || question.english || Object.values(question).find(Boolean) || '';
  }
  return String(question);
}

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className, orders,onPageChange,onPageLimit, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showpreview, setShowpreview] = useState(false);
  const [previewurl, setpreviewurl] = useState('');

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
    onPageChange(page)
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    onPageLimit(event.target.value)
  };
  const toggleActive = (order) => (event) => {
    if (props.onStatusChange) {
      props.onStatusChange(order, event.target.checked);
    }
  };
  function previewimage(url)
  {
    setpreviewurl(url)
    setShowpreview(true)
  }
  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };


  return (
    <>
    {showpreview && (
          <Lightbox
            mainSrc={previewurl}
           // nextSrc={images[(photoIndex + 1) % images.length]}
           // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setShowpreview(false)}
            onMovePrevRequest={() =>
              alert('prev')
            }
            onMoveNextRequest={() =>
              alert('next')
            }
          />
        )}
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Survey"
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S no</TableCell>
                    <TableCell>Question</TableCell>
                  
                  
                  
                    <TableCell>Responses</TableCell>
                    <TableCell>status</TableCell>
                    <TableCell>CreatedAt</TableCell>
                    <TableCell align="center">Actions</TableCell>
                    {/* <TableCell align="center">View</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(orders || []).slice(0, rowsPerPage).map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                      {(page * rowsPerPage)+(index+1)}
                        
                      </TableCell>

                      
                      <TableCell>{displayQuestion(order.question)}</TableCell>
                      <TableCell>{order.response_count || 0}</TableCell>
                      <TableCell>
                        <Switch
                          checked={!!order.is_active}
                          color="primary"
                          onChange={toggleActive(order)}
                          name={`survey-active-${order.id}`}
                          inputProps={{ 'aria-label': 'Activate survey' }}
                        />
                        <Label
                          color={paymentStatusColors[order.is_active ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.is_active ? 'Active' : 'Inactive'}
                        </Label>
                        {order.is_announced ? (
                          <span style={{ marginLeft: 8 }}>
                            <Label color={paymentStatusColors.active} variant="contained">
                              Announced
                            </Label>
                          </span>
                        ) : null}
                      </TableCell>
                      <TableCell>
                      <Typography variant="body1">
                          {moment(order.createdAt).format(
                            'DD MMM YYYY | hh:mm a'
                          )}
                        </Typography>
                      </TableCell>
                     
                      <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/editsurvey/${order.id}`}
                          variant="outlined"
                        >
                          Edit
                        </Button>
                        {' '}
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/surveyresults/${order.id}`}
                          variant="outlined"
                        >
                          Results
                        </Button>
                      </TableCell>
                      {/* <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={'/management/orders/1'}
                          variant="outlined"
                        >
                         View
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={props.totalcount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  onPageChange: PropTypes.func,
  onPageLimit : PropTypes.func,
  onStatusChange: PropTypes.func
};

Results.defaultProps = {
  orders: []
};

export default Results;
